import { TYPE_POURCENTAGE, TYPE_TRASANCTION_SALES, CALCULATION_BASE_BEFORE_TAX } from "@/constants/taxes";
export default {
  type: "taxes",
  active: true,
  name: null,
  label: null,
  tax_number: null,
  tax_type: TYPE_TRASANCTION_SALES,
  calculation_type: TYPE_POURCENTAGE,
  calculation_base: CALCULATION_BASE_BEFORE_TAX,
  value: null,
  excerpt: null,
  relationshipNames: ["organization"],
  organization: {
    type: "organizations",
    id: null,
  },
};
